import { Route } from 'react-router-dom';
import { reconductionsABloquerSchema } from './reconductionsABloquer';
import Main from '@app/main/tables/Main';

/**
 * Routes configurées pour le module ReconductionsABloquer
 */
const ReconductionsABloquerRoutes = [
    // Route de liste (principale)
    <Route
        key="reconductions-a-bloquer"
        path="reconductionsABloquerPourAssistantPotentiel"
        element={
            <Main
                key="reconductions-a-bloquer-main"
                pageConfig={reconductionsABloquerSchema}
            />
        }
    />,
];

export default ReconductionsABloquerRoutes;
